import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  Paper,
  Switch,
  useMediaQuery,
} from "@mui/material";
import { useState } from "react";
import BarraTitulo from "../../Generico/BarraTitulo";
import CompListaGrupo from "./CompListaGrupo";
import CadastroGrupo from "./compCadastroGrupo";
import { useTheme } from "@emotion/react";
const TitleMenu = ({
  ativos,
  handleChangeAtivos,
  handleOpenBusca,
  grupos,
  handleUpdateGrupo,
  handleListGrupos,
  handlePauseGrupo,
  duplicarProduto,
  setProdutoEdit,
  openCadProd,
  setOpenCadProd,
  setLoading,
  handlePauseProduto,
}) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const [state, setState] = useState({
    grupoObject: "",
    grupo: {
      tipoGrupoProduto: {},
      ativo: true,
      pausado: true,
    },
    idTipoGrupo: null,
    erros: { nomeGrupo: null },
  });

  const handleEditarGrupo = (group, event) => {
    event.stopPropagation();

    const grupoObject = group;
    const grupo = group.grupoProduto;
    const idTipoGrupo = group.grupoProduto.tipoGrupoProduto.id;

    setState((prevState) => ({
      ...prevState,
      grupoObject,
      grupo,
      idTipoGrupo,
    }));
    setOpen((prev) => !prev);
  };

  const createNewGrupo = () => {
    const grupo = {
      key: Math.floor(Math.random() * 1000),
      tipoGrupoProduto: {},
      ativo: true,
      pausado: true,
    };

    return {
      grupoProduto: grupo,
      produtos: [],
    };
  };

  const handleNewGroup = (event) => {
    const novoGrupo = createNewGrupo();
    handleEditarGrupo(novoGrupo, event);
  };
  return (
    <Box mt="2rem">
      <Box
        display="flex"
        flexDirection={isTablet ? "column" : "row"}
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Box sx={{ width: "100%" }}>
          <BarraTitulo
            title="CARDÁPIO"
            subTitle="Inserir itens, complementos e opcionais, definir disponibilidade e alterar preços."
          />
        </Box>

        <Box
          sx={{
            width: isTablet ? "100%" : "auto",
            minWidth: "10rem",
            marginBottom: "0.75rem",
          }}
        >
          <Button
            startIcon={<AddIcon />}
            variant="contained"
            color="primary"
            fullWidth
            onClick={(e) => handleNewGroup(e)}
          >
            Novo Grupo
          </Button>
        </Box>
      </Box>
      <Paper sx={{ padding: "1rem" }}>
        <Box
          sx={{ padding: "0.5rem" }}
          display="flex"
          justifyContent="space-between"
        >
          <Box>
            <Box p={2} display="inline">
              <FormControlLabel
                control={
                  <Switch checked={ativos} onChange={handleChangeAtivos} />
                }
                label={ativos ? "grupos ativos" : "grupos inativos"}
              />
            </Box>
          </Box>

          <Box>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleOpenBusca}
              endIcon={<SearchIcon />}
            >
              Buscar
            </Button>
          </Box>
        </Box>

        <Divider sx={{ margin: "1rem" }} />
        <Box>
          <CompListaGrupo
            handlePauseGrupo={handlePauseGrupo}
            setProdutoEdit={setProdutoEdit}
            setLoading={setLoading}
            duplicarProduto={duplicarProduto}
            openCadProd={openCadProd}
            setOpenCadProd={setOpenCadProd}
            ativos={ativos}
            grupos={grupos}
            handleUpdateGrupo={handleUpdateGrupo}
            handlePauseProduto={handlePauseProduto}
            handleEditarGrupo={handleEditarGrupo}
          />
        </Box>
      </Paper>
      <CadastroGrupo
        open={open}
        setOpen={setOpen}
        handleUpdateGrupo={handleUpdateGrupo}
        handleListGrupos={handleListGrupos}
        grupos={grupos}
        setState={setState}
        state={state}
      />
    </Box>
  );
};

export default TitleMenu;
